import axios from "@/axios";

export const namespaced = true;

export const state = {
  replacementItems: [],
  replacementItemReceiptStatus: false,
  replacementItemEnabled: false,
  replacementItemErrors: [],
};

export const getters = {
  replacementItems: (state) => {
    let replacementItems = [];
    if (state.replacementItems) {
      let replacementItemNumbers = state.replacementItems
        .filter((replacementItem) => parseInt(replacementItem.itemNumber))
        .map((replacementItem) => {
          return {
            ...replacementItem,
            itemNumber: parseInt(replacementItem.itemNumber),
          };
        });

      let replacementItemStrings = state.replacementItems.filter(
        (replacementItem) => !parseInt(replacementItem.itemNumber)
      );

      replacementItemNumbers = replacementItemNumbers.sort();
      if (replacementItemStrings) {
        replacementItemStrings = replacementItemStrings.sort();
        replacementItems = replacementItemNumbers.concat(
          replacementItemStrings
        );
      } else {
        replacementItems = replacementItemNumbers;
      }

      return replacementItems;
    }
  },
  replacementItemReceiptStatus: (state) => state.replacementItemReceiptStatus,
  replacementItemEnabled: (state) => state.replacementItemEnabled,
  replacementItemErrors: (state) => state.replacementItemErrors,
};

export const mutations = {
  SET_REPLACEMENT_ITEM: (state, response) => {
    state.replacementItem = Object.assign({}, defaultData, response.data);
  },
  SET_REPLACEMENT_ITEMS: (state, response) => {
    state.replacementItems = response.data;
  },
  SET_REPLACEMENT_ITEM_RECEIPT_STATUS(state, status) {
    state.replacementItemReceiptStatus = status;
  },
  SET_REPLACEMENT_ITEM_ENABLED(state, response) {
    state.replacementItemEnabled = response.data;
  },
  SET_ERRORS(state, data) {
    state.replacementItemErrors = data;
  },
  CLEAR_ERRORS(state) {
      state.replacementItemErrors = [];
  }
};

export const actions = {
  async getReplacementItems({ commit }, orderId) {
    commit(
      "SET_REPLACEMENT_ITEMS",
      await axios.get(`/api/replacementitems/order/${orderId}`)
    );
  },

  async getReplacementItemEnabled({ commit }, orderId) {
    commit(
      "SET_REPLACEMENT_ITEM_ENABLED",
      await axios.get(`/api/replacementreceiptitems/enabled/${orderId}`)
    );
  },

  async getReplacementItemReceiptStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_REPLACEMENT_ITEM_RECEIPT_STATUS", false);
    } else {
      return await axios
        .get("/api/replacementreceiptitems/status/" + id)
        .then(({ data }) => {
          commit("CLEAR_ERRORS");
          if(data && data.length === 0) {
            commit("SET_REPLACEMENT_ITEM_RECEIPT_STATUS", true);
            commit("CLEAR_ERRORS");
          } else {
          commit("SET_REPLACEMENT_ITEM_RECEIPT_STATUS", false);
            commit("SET_ERRORS", data);
        }
        });
    }
  },
  async saveReplacementItems({ state }, items) {
    return await axios.post("api/replacementreceiptitems/all", items);
  }
};
